angular.module('forms').controller('UpdateFamilyHistoryModalCtrl',
    ['$q', '$scope', '$uibModalInstance', 'ListService', 'FamilyHxRelationshipId', 'FamilyHistoryAnswer', 'HistoryRelationshipList', 'FormsId',
        function ($q, $scope, $modalInstance, ListService, FamilyHxRelationshipId, FamilyHistoryAnswer, HistoryRelationshipList, FormsId) {
            'use strict';

            $scope.loadingModal = true;

            $scope.FamilyHistoryAnswer = FamilyHistoryAnswer;

            $scope.familyHxRelationshipList = '';
            $scope.Model = {
                TimeFrameIdBirthdate: 'birthdate',
                TimeFrameIdDeathdate: 'deathdate',
                RelationshipQualifier: 4
            };

            $scope.RelationshipQualifier = {
                isMaternal: 1,
                isPaternal: 2,
                isUnknown: 3,
                none: 4
            };
            $scope.Model.RelationshipQualifier = $scope.RelationshipQualifier.none;


            function loadModal() {
                if ($scope.FamilyHistoryAnswer.IsRelationshipMaternal === true) {
                    $scope.Model.RelationshipQualifier = $scope.RelationshipQualifier.isMaternal;
                } else if ($scope.FamilyHistoryAnswer.IsRelationshipPaternal === true) {
                    $scope.Model.RelationshipQualifier = $scope.RelationshipQualifier.isPaternal;
                } else if ($scope.FamilyHistoryAnswer.IsRelationshipUnknown === true) {
                    $scope.Model.RelationshipQualifier = $scope.RelationshipQualifier.isUnknown;
                } else {
                    $scope.Model.RelationshipQualifier = $scope.RelationshipQualifier.none;
                }

                $scope.familyHxRelationshipList = HistoryRelationshipList;
                $scope.loadingModal = false;
            }
            loadModal();


            $scope.relationshipSelect = function relationshipSelect() {
                var selectedRelationship = _.find($scope.familyHxRelationshipList, {ItemId: FamilyHistoryAnswer.RelationshipId});
                if (selectedRelationship) {
                    FamilyHistoryAnswer.RelationshipName = selectedRelationship.Name;
                }
            };


            $scope.timeFrameSelectedCallback = function timeFrameSelectedCallback(timeFrameId, onsetTimeFrameId) {
                var problemHistoryAnswer = _.find($scope.FamilyHistoryAnswer.ProblemHistoryAnswers, {ProblemHistoryAnswerId: timeFrameId});
                if (problemHistoryAnswer) {
                    if ((onsetTimeFrameId.toUpperCase() === FormsId.TimeFrameId.Clear) || (onsetTimeFrameId === '')) {
                        problemHistoryAnswer.Selected = false;
                        problemHistoryAnswer.Notes = '';
                    } else {
                        problemHistoryAnswer.Selected = true;
                    }
                }
            };


            $scope.accept = function accept() {
                $scope.familyHistoryForm.isSubmitted = true;
                if (!$scope.familyHistoryForm.$valid) {
                    return;
                }

                $scope.FamilyHistoryAnswer.IsRelationshipMaternal = false;
                $scope.FamilyHistoryAnswer.IsRelationshipPaternal = false;
                $scope.FamilyHistoryAnswer.IsRelationshipUnknown  = false;

                if ($scope.Model.RelationshipQualifier === $scope.RelationshipQualifier.isMaternal) {
                    $scope.FamilyHistoryAnswer.IsRelationshipMaternal = true;
                } else if ($scope.Model.RelationshipQualifier === $scope.RelationshipQualifier.isPaternal) {
                    $scope.FamilyHistoryAnswer.IsRelationshipPaternal = true;
                } else if ($scope.Model.RelationshipQualifier === $scope.RelationshipQualifier.isUnknown) {
                    $scope.FamilyHistoryAnswer.IsRelationshipUnknown  = true;
                }

                $scope.familyHistoryForm.isSubmitted = false;
                $modalInstance.close(FormsId.ModalInstanceReturnId.Accept);
            };


            $scope.cancel = function cancel() {
                $modalInstance.dismiss(FormsId.ModalInstanceReturnId.Cancel);
            };
        }
    ]
);